import React from 'react';
import './Icon.scss';

function Icon(props) {
  const { name, size } = props;
  return (
    <i
      {...props}
      class={['icon', `icon-${name}`].join(' ')}
      style={{ width: `${size}px`, height: `${size}px` }}
    >
      {props.children}
    </i>
  );
}

export default Icon;
